<template lang="pug">
  Bar(
    :id="chartId"
    :chartOptions="options"
    :chartData="chartData"
    ref="chart"
    @click="handleClick"
  )
</template>

<script>
import { Bar } from 'vue-chartjs/legacy'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
  name: 'BarChart',
  components: { Bar },
  props: {
    chartId: {
      type: String,
      required: true
    },
    chartData: {
      type: Object,
      required: true
    },
    listenEvents: {
      type: Boolean,
      required: false
    },
  },
  data() {
    return {
      options: {
        title: {
          display: true,
          text: 'Мониторинг активности'
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    }
  },
  mounted() {
    if (this.listenEvents) {
      this.$nextTick(() => {
        const canvas = this.$el.querySelector('canvas')
        canvas.addEventListener('click', this.handleClick)
      })
    }
  },
  beforeDestroy() {
    if (this.listenEvents) {
      this.$nextTick(() => {
        const canvas = this.$el.querySelector('canvas')
        canvas.removeEventListener('click', this.handleClick)
      })
    }

  },
  methods: {
    handleClick(event) {
      if (this.listenEvents) {
        const chart = this.$refs.chart.$data._chart;
        const activeElements = chart.getElementsAtEventForMode(event, 'nearest', { intersect: true }, false);
        if (activeElements && activeElements.length > 0) {
          const activeElement = activeElements[0];
          const datasetIndex = activeElement.datasetIndex;
          const type = chart.data.datasets[datasetIndex].labelName;
          const label = chart.data.datasets[datasetIndex].label;
          const index = activeElement.index;
          const user = chart.data.labels[index];
          this.$emit('showUserOrdersIds', { type, user, label });
        }
      }
    }
  }
}
</script>
